import React from "react";
import { Link, withRouter } from "react-router-dom"; // ✅ Import withRouter
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

class UserActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };

    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    localStorage.removeItem("isAuthenticated"); // Clear auth
    this.props.history.push("/login"); // ✅ Redirect using history
  }

  toggleUserActions() {
    this.setState({ visible: !this.state.visible });
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="user-avatar rounded-circle mr-2"
            src={require("./../../../../images/avatars/1.jpg")}
            alt="User Avatar"
          />{" "}
          <span className="d-none d-md-inline-block">{localStorage.getItem('name')}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
         {
           localStorage.getItem("userRole") == 'Expert' && <DropdownItem onClick={() => this.props.history.push("/profile")}>
           <i className="material-icons">&#xE7FD;</i> Profile
         </DropdownItem>
         }
          
          <DropdownItem tag={Link} to="/" className="text-danger" onClick={this.handleLogout}>
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}

// ✅ Wrap the component with `withRouter` to inject history
export default withRouter(UserActions);
